declare global {
  interface Window {
    cotd: {
      miniCart?: {
        getCart: Function;
      };
      buyForm?: unknown;
      isMobileWeb?: boolean;
      androidApp?: unknown;
    };
  }
}

export const getLegacyMinicart = () =>
  typeof window != "undefined" && window?.cotd?.miniCart
    ? window.cotd.miniCart
    : undefined;
